import { render, staticRenderFns } from "./pgd-git.vue?vue&type=template&id=1bf166e9"
import script from "./pgd-git.vue?vue&type=script&lang=js"
export * from "./pgd-git.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports